import React, { FC } from "react";
import {
  Typography,
  Paper,
  IconButton,
  SelectChangeEvent,
} from "@mui/material";
import {
  Info as InfoIcon,
  ArrowBackIos,
  ArrowForwardIos,
  Circle as CircleIcon,
  CircleOutlined as CircleOutlineIcon,
} from "@mui/icons-material";
import BifoldTypeSelect from "../BifoldTypeSelect";
// import WindowSelect from "../WindowSelect";
import "../RemoveEditDuplicate/EditBtn.css";
import { styled } from "@mui/material/styles";
import useCarouselSelection from "./useCarouselSelection";

const StyledPaper = styled(Paper)({
  "&:hover": { cursor: "pointer" },
  padding: 10,
  margin: 10,
});

const StyledDivCol = styled("div")({
  padding: 10,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
});

const StyledDivTitle = styled("div")({
  backgroundColor: "white",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  border: "groove",
  borderRadius: 5,
  borderColor: "#4b4b4b",
  paddingBottom: 0,
  boxShadow: "0px 2px 3px gray",
  position: "relative",
  overflow: "hidden",
});

const StyledArrowBoxLeft = styled("div")({
  width: 50,
  height: "100%",
  position: "absolute",
  left: 0,
  zIndex: 20,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#c3cbdc",
  // backgroundColor: "rgb(195, 203, 220, 0.3)",
  backgroundImage: "linear-gradient(to right, #c3cbdc 0%, #ffffff 100%)",
  cursor: "pointer",
});

const StyledArrowBoxRight = styled("div")({
  width: 40,
  height: "100%",
  position: "absolute",
  right: 0,
  zIndex: 20,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#c3cbdc",
  backgroundImage: "linear-gradient(to left, #c3cbdc 0%, #ffffff 100%)",
  cursor: "pointer",
});

const StyledBifoldImg = styled("img")(({ theme }) => ({
  width: 250,
  height: 220,
  objectFit: "contain",
  [theme.breakpoints.down("md")]: {
    width: 200,
    height: 200,
  },
  [theme.breakpoints.down("sm")]: {
    width: 150,
    height: 150,
  },
}));

const StyledSliderImg = styled("img")(({ theme }) => ({
  width: 300,
  height: 220,
  objectFit: "contain",
  [theme.breakpoints.down("md")]: {
    width: "auto",
    height: 200,
  },
  [theme.breakpoints.down("sm")]: {
    width: "auto",
    height: 150,
  },
}));

const StyledPivotImg = styled("img")(({ theme }) => ({
  width: 150,
  height: 220,
  objectFit: "contain",
  [theme.breakpoints.down("md")]: {
    width: "auto",
    height: 200,
  },
  [theme.breakpoints.down("sm")]: {
    width: "auto",
    height: 150,
  },
}));

const StyledSwingImg = styled("img")(({ theme }) => ({
  width: 200,
  height: 220,
  objectFit: "contain",
  [theme.breakpoints.down("md")]: {
    width: "auto",
    height: 200,
  },
  [theme.breakpoints.down("sm")]: {
    width: "auto",
    height: 150,
  },
}));

const StyledFixedImg = styled("img")(({ theme }) => ({
  width: 100,
  height: 220,
  objectFit: "contain",
  [theme.breakpoints.down("md")]: {
    width: "auto",
    height: 200,
  },
  [theme.breakpoints.down("sm")]: {
    width: "auto",
    height: 150,
  },
}));

const StyledContentDiv = styled("div")({
  backgroundColor: "#fafafa",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
});

const StyledCarouselDiv = styled("div")(({ theme }) => ({
  backgroundColor: "white",
  display: "flex",
  transition: "transform 0.3s ease-in-out",
  flexWrap: "nowrap",
  padding: 20,
  [theme.breakpoints.down("lg")]: {
    padding: 0,
    paddingTop: 40,
    paddingBottom: 40,
  },
  [theme.breakpoints.down("md")]: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

const StyledCarouselItmDiv = styled("div")(({ theme }) => ({
  width: "calc(100% - 70px)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  transition: "1s cubic-bezier(0.39, 0.575, 0.565, 1)",
  padding: 40,
  paddingTop: 10,
  [theme.breakpoints.down("md")]: {
    paddingTop: 10,
    paddingBottom: 30,
  },
  [theme.breakpoints.down("sm")]: {
    width: "100vw",
  },
}));

const StyledPagesDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  marginTop: -50,
  paddingBottom: 20,
  alignSelf: "center",
});

const StyledArrowIconBack = styled(ArrowBackIos)({
  color: "black",
  fontSize: 50,
  "&:hover": {
    fontSize: 60,
  },
  marginLeft: 20,
});

const StyledArrowIconFront = styled(ArrowForwardIos)({
  color: "black",
  fontSize: 50,
  "&:hover": {
    fontSize: 60,
  },
});

const CLOUDINARY_URL =
  "https://res.cloudinary.com/ag-millworks/image/upload/UnitGifs";
const AG_URL = "https://www.agmillworks.com/product";

const data = [
  {
    img: `${CLOUDINARY_URL}/bifoldGifPic.jpg`,
    jif: `${CLOUDINARY_URL}/bifold_gif.gif`,
    val: "bifold",
    title: "Bi-Fold Door",
    href: `${AG_URL}/folding-door-systems`,
  },
  {
    img: `${CLOUDINARY_URL}/sliderGifPic.jpg`,
    jif: `${CLOUDINARY_URL}/slider_gif.gif`,
    val: "slider",
    title: "Sliding Door",
    href: `${AG_URL}/sliding-door-systems`,
  },
  {
    img: `${CLOUDINARY_URL}/swingGifPic.jpg`,
    jif: `${CLOUDINARY_URL}/swing_gif.gif`,
    val: "swing",
    title: "French Swing Door",
    href: `${AG_URL}/french-swing-doors`,
  },
  {
    img: `${CLOUDINARY_URL}/pivotGifPic_v3.jpg`,
    jif: `${CLOUDINARY_URL}/pivot_gif_v3.gif`,
    val: "pivot",
    title: "Pivot Door",
    href: `${AG_URL}/pivot-door-systems`,
  },
  {
    img: `${CLOUDINARY_URL}/fullbound3.jpg`,
    jif: `${CLOUDINARY_URL}/fullbound3.jpg`,
    val: "fixed",
    title: "Fixed Panel",
    href: ``,
  },
];

interface CarouselProps {
  reset: () => void;
  handleBifoldChange: (event: SelectChangeEvent<string>) => void;
  windowOrDoor: string;
  // handleWindowChange: (event: SelectChangeEvent<string>) => void;
  // windowVal: string;
  bifold: string;
}

const Carousel: FC<CarouselProps> = ({
  reset,
  handleBifoldChange,
  windowOrDoor,
  // windowVal,
  bifold,
  // handleWindowChange
}) => {
  const {
    handleTouchEnd,
    handleTouchMove,
    handleTouchStart,
    pageClick,
    shiftRight,
    shiftLeft,
    hover,
    numPages,
    handleHover,
    handleClick,
    boxRef,
    carouselRef,
    largeScreen,
    mediumScreen,
    index,
  } = useCarouselSelection(reset, bifold);

  const cyan = "#57d5f2";

  const handleImgGif = (item: {[key: string]: string}) => {
    return hover === item.title ? item.jif : item.img
  }

  const handleFontColor = (item: {[key: string]: string}) => {
    return { color: hover === item.title ? cyan : "" }
  }

  return (
    <StyledContentDiv>
      <StyledDivTitle
        style={{
          width: largeScreen ? 1300 : mediumScreen ? 780 : 360,
          alignItems: largeScreen
            ? "flex-start"
            : mediumScreen
            ? "flex-end"
            : "flex-start",
        }}
      >
        {largeScreen || mediumScreen ? (
          <Typography
            style={{ alignSelf: "center", marginTop: 10 }}
            variant="h4"
          >
            Select a Unit Type to Build
          </Typography>
        ) : (
          <Typography style={{ alignSelf: "center" }} variant="h6">
            Select a Unit Type
          </Typography>
        )}

        <StyledArrowBoxLeft onClick={shiftLeft}>
          <StyledArrowIconBack />
        </StyledArrowBoxLeft>
        <StyledArrowBoxRight onClick={shiftRight}>
          <StyledArrowIconFront />
        </StyledArrowBoxRight>

        <StyledCarouselDiv
          ref={carouselRef}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {data.map((item, idx) => (
            <StyledCarouselItmDiv
              key={idx}
              style={{
                alignSelf:
                  item.title === "Fixed Panel" || item.title === "Window" ? "flex-start" : "center",
              }}
              ref={boxRef}
            >
              <StyledPaper
                onClick={() => handleClick(item.val)}
                onMouseEnter={() => handleHover(item.title)}
                onMouseLeave={() => handleHover("")}
                elevation={3}
                style={{
                  border: hover === item.title ? `4px solid ${cyan}` : "",
                }}
              >
                {item.val === "bifold" ? (
                  <StyledBifoldImg
                    src={handleImgGif(item)}
                    alt={item.title}
                  />
                ) : item.val === "slider" ? (
                  <StyledSliderImg
                    src={handleImgGif(item)}
                    alt={item.title}
                  />
                ) : item.val === "swing" || item.val === "window" ? (
                  <StyledSwingImg
                    src={handleImgGif(item)}
                    alt={item.title}
                  />
                ) : item.val === "pivot" ? (
                  <StyledPivotImg
                    src={handleImgGif(item)}
                    alt={item.title}
                  />
                ) : (
                  <StyledFixedImg
                    src={handleImgGif(item)}
                    alt={item.title}
                  />
                )}
              </StyledPaper>

              <StyledDivCol>
                {item.title === "Fixed Panel" &&
                !largeScreen &&
                !mediumScreen ? (
                  <>
                    <Typography
                      style={handleFontColor(item)}
                      variant="h6"
                    >
                      Fixed
                    </Typography>
                    <Typography
                      style={handleFontColor(item)}
                      variant="h6"
                    >
                      Panel
                    </Typography>
                  </>
                ) 
                // : item.title === "Window" ? (
                //   <WindowSelect
                //     hover={hover}
                //     fontSize="1.25rem"
                //     handleChange={handleWindowChange}
                //     windowValue={windowVal}
                //   />
                // ) 
                : item.title !== "Bi-Fold Door" ? (
                  <Typography
                    style={handleFontColor(item)}
                    variant="h6"
                  >
                    {item.title}
                  </Typography>
                ) : (
                  <BifoldTypeSelect
                    hover={hover}
                    fontSize="1.25rem"
                    handleChange={handleBifoldChange}
                    windowOrDoor={windowOrDoor}
                  />
                )}

                {item.title !== "Fixed Panel" && item.title !== "Window" ? (
                  <Typography variant="caption" style={{ paddingLeft: 5 }}>
                    Learn More
                    <a href={item.href} target="_blank" rel="noreferrer">
                      <IconButton color="primary" size="large">
                        <InfoIcon />
                      </IconButton>
                    </a>
                  </Typography>
                ) : (
                  <div />
                )}
              </StyledDivCol>
            </StyledCarouselItmDiv>
          ))}
        </StyledCarouselDiv>

        <StyledPagesDiv>
          {Array.from(Array(numPages).keys()).map((num) => (
            <IconButton
              size="small"
              key={num}
              onClick={() =>
                pageClick(largeScreen ? num + 1 : mediumScreen ? num : num + 1)
              }
            >
              {index === num + 1 ? (
                <CircleIcon style={{ fontSize: 10 }} />
              ) : (
                <CircleOutlineIcon style={{ fontSize: 10 }} />
              )}
            </IconButton>
          ))}
        </StyledPagesDiv>
      </StyledDivTitle>
    </StyledContentDiv>
  );
};

export default Carousel;
